export const boardlist='/api/boards'
export const board='/api/boards/:boardId'
export const filelist='/api/files/upload'
export const file='/api/files/:id'
export const boardcolumnlist='/api/boardcolumns'

export const pointlist='/api/points'
export const taskfilelist='/api/taskfiles'
export const tasklist='/api/tasks'
export const userboardlist='/api/userboards'
export const userplanlist='/api/userplans'
export const userlist='/api/users'
export const authlogin='/api/auth'
